import React, { useEffect, useRef, useState } from "react";

export default function RecentTitlesSlider({ children }) {
  const track = useRef(null);
  const [edges, setEdges] = useState({ start: true, end: true });
  useEffect(() => {
    const el = track.current;
    const update = () => setEdges({ start: el.scrollLeft <= 1, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 2 });
    update();
    el.addEventListener("scroll", update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => { el.removeEventListener("scroll", update); observer.disconnect(); };
  }, [children]);
  const move = direction => {
    const el = track.current;
    const card = el.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(el).columnGap) || 0;
    el.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };
  return <div className="recent-slider">
    <div className="recent-slider-controls" aria-label="Recent titles navigation">
      <button type="button" className="action-button action-button-secondary" aria-label="Previous titles" disabled={edges.start} onClick={() => move(-1)}>←</button>
      <button type="button" className="action-button action-button-secondary" aria-label="Next titles" disabled={edges.end} onClick={() => move(1)}>→</button>
    </div>
    <div ref={track} className="recent-slider-track" role="region" aria-label="Recent titles cards" tabIndex={0} onKeyDown={event => {
      if (event.target !== event.currentTarget) return;
      if (["ArrowLeft", "ArrowRight"].includes(event.key)) { event.preventDefault(); move(event.key === "ArrowLeft" ? -1 : 1); }
    }}>{children}</div>
  </div>;
}
